import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import InfiniteScroll from "react-infinite-scroll-component";
import { useMemo, useState } from "react";

import { ReservationTableItem } from "components/molecules";
import { ListLoader } from "components/atoms";

import { Reservation } from "models/reservations";

import {
	getPropertyReservations,
	getPropertyReservationsCount,
	getPropertyReservationsList,
	getPropertyReservationsLoading,
	// getPropertyReservationsTotal,
} from "state/modules/properties";

import { FONT_FAMILY_MEDIUM } from "styles/typography";
import { MAIN_THEME } from "styles/colors";
import { Property } from "models/properties";
import { ReportTableItemWithTransfer } from "interfaces/reports";
import ReservationDetailsPanel from "./ReservationDetailsPanel";
import ReservationsList from "./ReservationsList";

interface TableProps {
	columns: string;
}

const Table = styled.div`
	padding: 15px 30px 40px;
	overflow-y: auto;
	
	@media (max-width: 768px) {
		padding: 15px 10px 70px;
	}

	@media (max-width: 480px) {
		padding: 15px 5px 70px;
	}
`;

const TableHeader = styled.div<TableProps>`
	display: grid;
	grid-template-columns: ${(props) => props.columns};
	gap: 1px;
	margin-bottom: 1px;
	border-top-right-radius: 16px;
	border-top-left-radius: 16px;
	overflow: hidden;
	background: transparent;
	border-bottom: 1px solid ${MAIN_THEME.BORDER_COLOR};
`;

const TableHeaderItem = styled.div`
	font-size: 14px;
	text-align: center;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 38px;
	color: ${MAIN_THEME.TEXT_SECONDARY};
			background: transparent;


		font-weight: 600;
		text-transform: none;
		letter-spacing: 0.3px;


	@media (max-width: 768px) {
		font-size: 12px;
		height: 36px;
	}
`;

// const ReservationsList = styled(InfiniteScroll as any)`
// 	display: grid;
// 	width: 100%;
// 	grid-template-columns: 1fr;
// 	gap: 1px;
// `;

const EmptyListMessageContainer = styled.div`
	background: ${MAIN_THEME.DARK_BG_TERTIARY};
	border: 1px solid ${MAIN_THEME.BORDER_COLOR};
	padding: 15px;
	border-radius: 8px;
	margin: 15px 30px 40px;

	@media (max-width: 768px) {
		margin: 15px 10px 40px;
	}
`;

const EmptyListMessage = styled.p`
	font-family: ${FONT_FAMILY_MEDIUM};
	color: ${MAIN_THEME.TEXT_SECONDARY};
	font-size: 16px;
	margin: 0;
`;

interface Props {
	propertyDetails: Property;
}

const PropertyReservationsList = (props: Props): JSX.Element => {
	const [selectedReservation, setSelectedReservation] =
		useState<ReportTableItemWithTransfer | null>(null);

	const { propertyDetails } = props;

	const propertyReservations = useSelector(getPropertyReservationsList);
	// const propertyReservationsTotal = useSelector(getPropertyReservationsTotal);
	// const propertyReservationsCount = useSelector(getPropertyReservationsCount);
	const isPropertyReservationsLoading = useSelector(
		getPropertyReservationsLoading
	);

	const dispatch = useDispatch();

	// const hasMore = useMemo(
	// 	() => propertyReservationsCount < propertyReservationsTotal,
	// 	[propertyReservationsCount, propertyReservationsTotal]
	// );

	// const loadMore = () => {
	// 	if (!isPropertyReservationsLoading) {
	// 		dispatch(getPropertyReservations(propertyDetails.id, true));
	// 	}
	// };

	const handleCloseDetailsPanel = () => {
		setSelectedReservation(null);
	};

	const handleSelectReservation = (
		reservation: ReportTableItemWithTransfer | null
	) => {
		setSelectedReservation(reservation);
	};

	const renderEmptyListMessage = () => (
		<EmptyListMessageContainer>
			<EmptyListMessage>Empty list</EmptyListMessage>
		</EmptyListMessageContainer>
	);

	const renderReservationDetails = () => {
		if (selectedReservation) {
			return (
				<ReservationDetailsPanel
					close={handleCloseDetailsPanel}
					hostServiceFee={`${selectedReservation._item.host_service_fee}`}
					ownerIncome={`${selectedReservation._item.owner_income}`}
					hoteliseHelp={`${selectedReservation._item.hotelise_help}`}
					payoutPrice={`${selectedReservation._item.payout_price}`}
					propertyName={propertyDetails.name || ""}
					currency={selectedReservation._item.currency}
					propertyAddress={propertyDetails?.address?.display || ""}
					checkIn={selectedReservation._item.start_date}
					checkOut={selectedReservation._item.end_date}
					nights={selectedReservation._item.nights}
					guestsNumber={1}
					image={propertyDetails.picture || ""}
					cleaningFee={selectedReservation._item.cleaning ? `${selectedReservation._item.cleaning}` : undefined}
					guest={selectedReservation._item.guest}
				/>
			);
		}
	};

	return !isPropertyReservationsLoading && !propertyReservations.length ? (
		renderEmptyListMessage()
	) : (
		<Table>
			<ReservationsList
				reservations={propertyReservations}
				isLoading={isPropertyReservationsLoading}
				onSelect={handleSelectReservation}
			/>
			{renderReservationDetails()}
		</Table>
	);
};

export default PropertyReservationsList;
